import {
  Button,
  FormControl,
  FormLabel,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Select,
  useDisclosure,
  useToast,
} from "@chakra-ui/react";
import { useState } from "react";
import NotificationService from "../../services/Notification";
import { useNavigate } from "react-router-dom";
import { DateTime } from "luxon";
export const SelectedUsersNotificationModal = ({
  isOpen,
  onClose,
  users,
}: any) => {
  const token = localStorage.getItem("logged_in_user_token");
  const [category, setCategory] = useState("");
  const [notificationId, setNotificationId] = useState<any>("");
  const [data, setData] = useState([]);
  const toast = useToast();
  const navigate = useNavigate();
  const fetchData = () => {
    NotificationService.getNotification(token, 1, 1000, category)
      .then((res) => {
        setData(res.data.data);
        // onClose()
      })
      .catch((error) => {
        if (error.response.status === 401) {
          toast({
            position: "top",
            title: "Authentication Failed.",
            description: "Your session is expired.",
            status: "error",
            duration: 500,
            isClosable: true,
          });
          setTimeout(() => {
            navigate("/login");
          }, 2000);
        }
        console.log(error);
      });
  };

  const closeModal = () => {
    clearState();
    onClose();
  };
  const clearState = () => {
    setCategory("");
    setNotificationId("");
    setData([]);
  };
  function getFormattedDateTime() {
    const now = DateTime.local();
    const formattedDate = now.toFormat("MM/dd/yyyy");

    const formattedTime = now.toFormat("hh:mm a");

    return {
      date: formattedDate,
      time: formattedTime,
    };
  }


  const handleSubmit = () => {
    const data = {
      notification_id: notificationId,
      application_type: "USER",
      lead_ids: users,
      notification_status: "PENDING",
      source: "MANUAL",
      schedule_date: getFormattedDateTime().date,
      schedule_time: getFormattedDateTime().time,
      variable_values: [],
      error: [],
      target: "group",
    };
    NotificationService.createNotifcationEvent(data);
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={closeModal}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Select Notifications</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <FormControl>
            <FormLabel htmlFor="category-select">Select Category</FormLabel>
            <Select
              name=""
              id="category-select"
              onChange={(e) => {
                setCategory(e.target.value);
                fetchData();
              }}
            >
              <option value="">Select Category</option>
              <option value={"general"}>General</option>
              <option value={"assessment"}>Assessment</option>
              <option value={"ehc"}>EHC</option>
              <option value={"single_session"}>Single session</option>
              <option value={"subscription"}>Subscription</option>
              <option value={"renew_subscription"}>Renew Subscription</option>
              <option value={"special_day_offer"}>Special day offer</option>
              <option value={"campaign"}>Campaign</option>
            </Select>
          </FormControl>
          {category && (
            <FormControl mt={"25px"}>
              <FormLabel htmlFor="notication-select">
                Select Notication By Name
              </FormLabel>
              <Select
                name=""
                id="notication-select"
                onChange={(e) => setNotificationId(e.target.value)}
              >
                <option value="">Select Notification</option>
                {data.length > 0 ? (
                  data.map((el: any) => (
                    <option value={el._id}>{el.name}</option>
                  ))
                ) : (
                  <option value="" disabled>
                    No data found
                  </option>
                )}
              </Select>
            </FormControl>
          )}
        </ModalBody>

        <ModalFooter>
          <Button
            bgColor="#327171"
            color={"white"}
            mr={3}
            onClick={handleSubmit}
          >
            Send
          </Button>
          <Button bgColor="red" color={"white"} mr={3} onClick={closeModal}>
            No
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
